// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popper[data-v-18732603]{z-index:1000;cursor:auto}", ""]);
// Exports
module.exports = exports;
